import { render } from "./AdminSchedule.vue?vue&type=template&id=e22e72e4&scoped=true"
import script from "./AdminSchedule.vue?vue&type=script&lang=js"
export * from "./AdminSchedule.vue?vue&type=script&lang=js"

import "./AdminSchedule.vue?vue&type=style&index=0&id=e22e72e4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e22e72e4"]])

export default __exports__